import { render, staticRenderFns } from "./DropdownSectionItem.vue?vue&type=template&id=718e8f3a&scoped=true"
import script from "./DropdownSectionItem.vue?vue&type=script&lang=ts"
export * from "./DropdownSectionItem.vue?vue&type=script&lang=ts"
import style0 from "./DropdownSectionItem.vue?vue&type=style&index=0&id=718e8f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e8f3a",
  null
  
)

export default component.exports